module.exports = "images/meet-the-mad-scientists_poster.webp";